module.exports = __webpack_public_path__ + "839988b5ccf7358241f0b3a76502ea9c.svg";